import React from 'react';
import { useParams } from 'react-router-dom';

import styled from '@emotion/styled';

import { Modal } from '../../components/Modal/Modal';
import { TableComponent } from '../../components/TableCom';
import { ModalProvider } from '../../context/ModalContext';
import { TableRefreshProvider } from '../../context/TableRefreshContext';
import CreateAreaPrice from '../../sections/dashboard/warehouse/CreateAreaPrice';
import CreateAreaPriceModal from '../../sections/dashboard/warehouse/CreateAreaPriceModal';

const WarehouseArea = () => {
  const { warehouseId } = useParams();

  return (
    <TableRefreshProvider>
      <ModalProvider>
        <Container>
          <CreateAreaPrice />
          <TableComponent
            tableBaseUrl={`general-service/v1/prices/warehouse/${warehouseId}`}
            tableHeader={['areaName', 'areaId', 'amount', 'createdDate']}
            mappingData={{
              areaName: 'Area Name',
              areaId: 'Area Id',
              amount: 'Amount',
              createdDate: 'Created Date',
            }}
          />
        </Container>
        <Modal>
          <CreateAreaPriceModal />
        </Modal>
      </ModalProvider>
    </TableRefreshProvider>
  );
};

export default WarehouseArea;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
